module.exports = __webpack_public_path__ + "static/img/11.73dc2f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/11.png
// module id = 30vR
// module chunks = 0